const PORTAL_HOSTS = new Set(['portal.mbbe.dev', 'portal-staging.mbbe.dev', 'portal-passive.mbbe.dev', 'portal-staging-passive.mbbe.dev', 'portal.localhost']);

export function isPortalHost(): boolean {
  if (import.meta.env.VITE_APP_TARGET === 'portal') return true;
  if (typeof window === 'undefined') return false;
  return PORTAL_HOSTS.has(window.location.hostname.toLowerCase());
}
